/*
 * @LastEditors: zjy zjy@originqc.com
 * @LastEditTime: 2024-04-22 17:32:44
 * @LastEditors: zjy
 * @LastEditTime: 2022-12-01 08:03:25
 */
import {message} from 'antd';
import axios, {AxiosInstance, AxiosResponse} from 'axios';
// import Cookie from 'react-cookies';
// import { getLanguageFromRedux } from '@/redux/common';
// const language = getLanguageFromRedux();
import { getLanguage } from '@/utils/utils';
const language = getLanguage();

// 返回res.data的interface
export interface IResponse {
  code: number | string;
  data: any;
  msg: string;
}

let base = '/';
// eslint-disable-next-line no-undef
const isDev = process.env.NODE_ENV;
if (isDev === 'development') {
  base = '/';
}
const configs = {
  baseURL: base,// 请求的公共地址部分
  timeout: 600000, // 请求超时时间 当请求时间超过5秒还未取得结果时 提示用户请求超时
  // 发生跨域请求时携带 cookie
  withCredentials: true,
  headers: {'Content-Type': 'application/json', 'cache-control': 'no-cache'}
};
const instance: AxiosInstance = axios.create(configs);

// interface ICustomAxiosRequestConfig extends AxiosRequestConfig {
//   headers?: any
// }

// axios实例拦截请求前
instance.interceptors.request.use(
  (config: any) => {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers['Origin-Language'] = language;
    // config.headers['Origin-Language'] = 'zh';
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// axios实例拦截响应后
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.status === 200) {
      const excludeUrl = ['uc/userInfo/getUserInfo.json', '/api/headMenu/menuList.json', 'uc/userInfo/userInfo.json']; // 不需要登录的接口
      const needLogin = !excludeUrl.includes(response.config.url??'');
      const { code } = response.data;
      if (needLogin && code === 401) {
        // 未登录跳转至等页面进行登录
        // 构造带参数的 URL
        const queryParams:any = new URLSearchParams(window.location.search);
        const toUrl = queryParams?.size > 0 ? `${window.location.pathname}?${queryParams.toString()}` : `${window.location.pathname}`
        window.location.href = `/${language}/l/login?forward=${toUrl}`;
        return;
      }
      return response.data;
    }
    message.error(response.status.toString());
    return response.data;
  },
  // 请求失败
  (error: any) => {
    console.log('interceptors.response', error);
    const {response} = error;
    if (response) {
      message.error(response.status || 'ERR_NETWORK');
      return Promise.reject(response.data);
    }
    message.error(error?.status || 'ERR_NETWORK');
    return Promise.reject(error);
    // Toast.error('网络连接异常,请稍后再试!');
  }
);

export default instance;



